import { render } from "./carouselHome.vue?vue&type=template&id=530ebd24"
import script from "./carouselHome.vue?vue&type=script&lang=js"
export * from "./carouselHome.vue?vue&type=script&lang=js"

import "./carouselHome.vue?vue&type=style&index=0&id=530ebd24&lang=css"

import exportComponent from "/home/runner/work/ic-lab/ic-lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__